export default __webpack_public_path__ + "static/media/evgeniy-course.8ab66cf5.png";